var map = {
	"./d_tree1_adult/autumn.png": "OxkU",
	"./d_tree1_adult/default.png": "NN8w",
	"./d_tree1_adult/winter.png": "jmxN",
	"./d_tree1_child/default.png": "OYBU",
	"./d_tree1_seed/default.png": "kviT",
	"./d_tree1_sprout/default.png": "uCk9",
	"./d_tree1_young/autumn.png": "WBAH",
	"./d_tree1_young/default.png": "Wbzq",
	"./d_tree1_young/winter.png": "1NMW",
	"./d_tree2_adult/default.png": "Uw3O",
	"./d_tree2_adult/spring.png": "wZz9",
	"./d_tree2_child/default.png": "gUUx",
	"./d_tree2_seed/default.png": "dTfZ",
	"./d_tree2_sprout/default.png": "qpXe",
	"./d_tree2_young/default.png": "xjFd",
	"./d_tree3_adult/default.png": "4nPH",
	"./d_tree3_adult/spring.png": "vOj4",
	"./d_tree3_adult/summer.png": "qPKr",
	"./d_tree3_adult/winter.png": "CgjP",
	"./d_tree3_child/default.png": "1Qhq",
	"./d_tree3_seed/default.png": "AziH",
	"./d_tree3_sprout/default.png": "0GHx",
	"./d_tree3_young/autumn.png": "WbQE",
	"./d_tree3_young/default.png": "DIMB",
	"./d_tree3_young/winter.png": "OqO9",
	"./s_tree1_adult/autumn.png": "rISv",
	"./s_tree1_adult/default.png": "l7rj",
	"./s_tree1_adult/winter.png": "Ad5Z",
	"./s_tree1_child/default.png": "8E9J",
	"./s_tree1_seed/default.png": "PpAM",
	"./s_tree1_sprout/default.png": "sWtF",
	"./s_tree1_young/autumn.png": "ppt+",
	"./s_tree1_young/default.png": "iIMY",
	"./s_tree1_young/winter.png": "w0pZ",
	"./s_tree2_adult/default.png": "haKs",
	"./s_tree2_adult/spring.png": "jKrO",
	"./s_tree2_adult/summer.png": "qfBd",
	"./s_tree2_adult/winter.png": "X0uh",
	"./s_tree2_child/default.png": "KZNH",
	"./s_tree2_seed/default.png": "7Jkv",
	"./s_tree2_sprout/default.png": "uy/A",
	"./s_tree2_young/autumn.png": "Ukws",
	"./s_tree2_young/default.png": "V+hC",
	"./s_tree2_young/winter.png": "pfX+",
	"./s_tree3_adult/autumn.png": "BN8a",
	"./s_tree3_adult/default.png": "UX/r",
	"./s_tree3_adult/summer.png": "utNi",
	"./s_tree3_adult/winter.png": "dlcS",
	"./s_tree3_child/default.png": "wEeN",
	"./s_tree3_seed/default.png": "ptRo",
	"./s_tree3_sprout/default.png": "pMpk",
	"./s_tree3_young/autumn.png": "Ax+Q",
	"./s_tree3_young/default.png": "eciJ",
	"./s_tree3_young/winter.png": "O8ht"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Umug";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units ^\.\/.*\.png$
// module id = Umug
// module chunks = 1